<template>
  <div class="wrap" :ref="`wrap-${item.con_id}`" :class="item.css_class">
    <iframe :src="htmlSrc" frameborder="0" :ref="`iframe-${item.con_id}`"></iframe>
  </div>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  computed: {
    htmlSrc() {
      return `${process.env.VUE_APP_VIDEO_BASE}/api/content/${this.item.con_id}`
    }
  },
  mounted() {
    this.initIframe()
  },
  methods: {
    initIframe() {
      setTimeout(() => {
        let sizeOfWrapper = this.$refs[`wrap-${this.item.con_id}`].getBoundingClientRect()
        let iframe = this.$refs[`iframe-${this.item.con_id}`];
        iframe.height = sizeOfWrapper.height
        iframe.width = sizeOfWrapper.width
      }, 0);
    }
  }
}
</script>

<style lang="scss" scoped>
.wrap {
  width: 100%;
  height: 100%
}
</style>
